import { AutoComplete, Input } from 'antd';
import React, { KeyboardEvent, useRef } from 'react';
import styled from 'styled-components';

import { ISearchBarProps } from './types';

const SearchContainerStyled = styled.div`
  .ant-input-wrapper {
    display: flex;
  }
  .ant-input-affix-wrapper {
    padding-top: 0;
    padding-bottom: 0;
  }
  .ant-input-search-button {
    display: block;
    align-items: center;
    justify-content: center;
  }
  * {
    margin: 0;
  }

  .ant-select {
    width: 100%;
  }

  & .ant-input-group-addon {
    width: auto;
  }

  & input {
    height: 36px;
  }

  .ant-input-group-wrap {
    width: auto;
  }
`;

const SearchBarTemplate: React.FC<ISearchBarProps> = ({
  onSearch,
  options,
  placeholder,
  onSearchStart,
  onChange,
  value,
}) => {
  const inputRef = useRef(null);
  return (
    <SearchContainerStyled>
      <AutoComplete defaultValue={value} onSelect={onSearch} onSearch={onSearch} options={options}>
        <Input.Search
          ref={inputRef}
          onChange={onChange}
          allowClear
          size='large'
          placeholder={placeholder || 'Search...'}
          onSearch={(v, e) => {
            if (e?.type === 'click' && ((e?.target as unknown) as any).type === 'button') {
              onSearchStart?.(inputRef);
            }
          }}
          onKeyUp={(v: KeyboardEvent) => {
            if (v.key === 'Enter') {
              onSearchStart?.(inputRef);
            }
          }}
        />
      </AutoComplete>
    </SearchContainerStyled>
  );
};
export default React.memo(SearchBarTemplate);
